import React from 'react';
import { Collapse, Icon, ListItem, Typography } from '@mui/material';
import { styles } from '../styles.ts';
import { StepStatus, TIdentificationStep } from '~/modules/identification/types.js';
import DoneIcon from '@mui/icons-material/Done';

interface ISidebarProps {
  value: TIdentificationStep;
  isSelected: boolean;
  onClick: () => void;
  isOpened: boolean;
}

export const SidebarItem = ({ onClick, isSelected, value, isOpened }: ISidebarProps) => {
  const isDisabled = value.stepStatus === StepStatus.disabled;
  const isCompleted = value.stepStatus === StepStatus.completed;
  const dataTestId = `sideBar-${value.name}-${value.stepStatus}${isSelected ? '-selected' : ''}`;
  const textColor = isSelected ? 'common.white' : isDisabled ? 'text.disabled' : '';

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    e.stopPropagation();
    if (!(isDisabled || isSelected)) onClick();
  };

  return (
    <ListItem
      onClick={handleClick}
      sx={(theme) => ({
        ...styles.listItem(theme),
        ...(isCompleted ? styles.completedListItem(theme) : {}),
        ...(isSelected ? styles.selectedListItem(theme) : {}),
        ...(isDisabled ? styles.disabledListItem : {}),
        ...(!isOpened ? styles.closedSidebarListItem : {}),
      })}
      data-testid={dataTestId}
    >
      {isCompleted && isOpened ? (
        <DoneIcon sx={isSelected ? styles.doneIconSelected : {}} />
      ) : (
        <Icon
          component={value.icon}
          sx={(theme) => ({
            ...styles.icon(theme),
            ...(isSelected ? styles.selectedIcon(theme) : styles.icon),
            ...(isDisabled ? styles.disabledIcon(theme) : {}),
          })}
          height={2}
          width={2}
        />
      )}
      <Collapse in={isOpened} orientation="horizontal" timeout={200}>
        <Typography
          variant="body2"
          sx={{
            minWidth: 160,
            color: textColor,
          }}
        >
          {value.sidebarTitle}
        </Typography>
      </Collapse>
    </ListItem>
  );
};
